const qs = require('qs')
const { showError } = require('../../libs/helper')

module.exports = {
  getLantai: (g, data) => {
    /* Call Api
    sensus-pengguna-b/ref/get-lantai
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-lantai`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
}
